import ServiceQueue from './base/service-manager/service-queue';

export default class ToastQueue extends ServiceQueue {
  getDuplicationKey(props) {
    const duplicatedItem = this.queue.find(item => {
      for (const key in props) {
        if (JSON.stringify(props[key]) !== JSON.stringify(item[key])) {
          return false;
        }
      }
      return true;
    });
    return duplicatedItem && duplicatedItem.key;
  }
}
